import React from "react";

export default function LexiqueSkeleton() {
  return (
    <div className="animate-pulse py-3">
      <div className="h-4 w-2/5 bg-slate-200 dark:bg-slate-800 rounded mb-2" />
      <div className="h-3 w-3/5 bg-slate-200 dark:bg-slate-800 rounded" />
    </div>
  );
}
